import { WFCreateStepOption } from "@/types/WorkflowCreate/workflowCreate"
import { WorkflowTaskOption } from "@/types/WorkflowCreate/workflowUpdateV2"

export const getOptionsDifference = (
  oldOptions: WorkflowTaskOption[] | undefined,
  newOptions: WFCreateStepOption[]
) => {
  const result: WorkflowTaskOption[] = []

  // Handle existing options (update or unchanged)
  oldOptions?.forEach(old => {
    const match = newOptions.find(nf => nf.option === old.option)
    if (match) {
      if (old.optionValue !== match.optionValue) {
        // Value updated → keep ID
        result.push({
          id: old.id,
          option: old.option,
          optionValue: match.optionValue
        })
      } else {
        // Unchanged → keep as is
        result.push({
          id: old.id,
          option: old.option,
          optionValue: old.optionValue
        })
      }
    } else {
      // Not found in new options → mark for removal
      result.push({
        id: old.id,
        option: old.option,
        optionValue: old.optionValue,
        remove: true
      })
    }
  })

  // Handle new options (no old entry)
  newOptions?.forEach(nf => {
    const alreadyExists = oldOptions?.some(of => of.option === nf.option)
    if (!alreadyExists) {
      result.push({
        option: nf.option,
        optionValue: nf.optionValue
      })
    }
  })

  return result
}
